import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputHintModule } from '../../generic-input-hint/generic-input-hint.module';
import { GenericInputSlotModule } from '../../generic-input-slot/generic-input-slot.module';
import { GenericDateInputComponent } from './generic-date-input.component';
import { GenericDirectivesModule } from '../../generic-directives/generic-directives.module';

export * from './generic-date-input.component';

@NgModule({
    declarations: [ GenericDateInputComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        TranslateModule,
        GenericInputHintModule,
        MatInputModule,
        GenericInputSlotModule,
        GenericDirectivesModule,
        MatDatepickerModule,
        MatButtonModule,
        MatIconModule,
    ],
    exports: [
        GenericDateInputComponent,
    ],
})
export class GenericDateInputModule {
}
